/**
 * Agent capability predicates.
 *
 * Centralizes checks that would otherwise be duplicated (and drift) across the
 * chat input and the send path. Whether a deployment is vision-capable is not
 * auto-detectable from its name, so it's an admin-declared flag on the
 * azure-ai-agent config — mirroring `reasoningConfig.supportsReasoning`.
 */

import type { Agent } from '@/types/agent.types';

/** True when the agent is an azure-ai-agent whose model can read images. */
export function agentSupportsVision(agent: Agent | null | undefined): boolean {
  return (
    agent?.config.framework === 'azure-ai-agent' &&
    agent.config.config.supportsVision === true
  );
}
